export const setCompanies = (state, payload) => state.companies = payload;

export const setSelectedCompanyId = (state, payload) => state.selectedCompanyId = payload;

export const setSearchedCompany = (state, payload) => state.searchedCompany = payload;

export const setCompanySearchResult = (state, payload) => state.searchResult = payload;
